import * as React from 'react';
import { EntityActionMenuItem } from '@web-config-app/core-react-ui';
import type {
  CustomWorkflowActionMenuItem,
  DomainEntity,
  EnvironmentKey,
  EntityConfigCustomOperation,
} from '@web-config-app/core';
import { useEntityCustomOperation } from '@web-config-app/core-react';
import type { UseEntityCustomOperationOptions } from '@web-config-app/core-react';

export interface CustomEntityActionMenuItemProps {
  item: Omit<CustomWorkflowActionMenuItem, 'operation'>;
  operation: EntityConfigCustomOperation;
  domainEntity: DomainEntity;
  instanceId?: string;
  data: any;
  entityName: string;
  environment: EnvironmentKey;
  registerCustomMenuAction: (itemId: string, action: () => void) => void;
  options: UseEntityCustomOperationOptions | undefined;
}

export const CustomEntityActionMenuItem = ({
  item,
  domainEntity,
  instanceId,
  data,
  environment,
  registerCustomMenuAction,
  entityName,
  operation,
  options,
}: CustomEntityActionMenuItemProps) => {
  const { mutate } = useEntityCustomOperation({
    domainEntity,
    data,
    instanceId,
    entityName,
    environment,
    operation,
    options,
  });

  /**
   * Register the custom action with the container, which needs to pass
   * the register function as a prop to this component.
   */
  React.useEffect(() => {
    if (!item.modal) {
      registerCustomMenuAction(item.id, mutate);
    }
  }, [item, mutate, registerCustomMenuAction]);

  const menuItem = {
    ...item,
    modal: item.modal ? { ...item.modal, confirmCtaAction: mutate } : undefined,
  };

  return <EntityActionMenuItem item={menuItem} />;
};
